import React from 'react';
import { Menu } from '@mui/icons-material';

interface SidebarToggleProps {
  visible: boolean;
  onToggle: () => void;
}

const SidebarToggle: React.FC<SidebarToggleProps> = ({ visible, onToggle }) => {
  if (visible) return null;

  return (
    <button
      onClick={onToggle}
      style={{
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '0 8px 8px 0',
        padding: '12px 8px',
        cursor: 'pointer',
        boxShadow: '2px 0 4px rgba(0,0,0,0.1)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Menu />
    </button>
  );
};

export default SidebarToggle;
